import Route from '@ember/routing/route'

export default class MathsRoute extends Route {
  queryParams = {
    studentGrade: {
      refreshModel: true,
      replace: true,
    },
    contentLevel: {
      refreshModel: true,
      replace: true,
    },
  }
}
